// export const baseURL = 'http://project.4dage.com:8036' //线上地址
//export const baseURL ='http://192.168.20.55:8036' //本地地址

// 本地化加上
export const baseURL ='' //甲方有服务器的打包地址
export const addNumAPI = (type) => {
  fetch(`${baseURL}/api/visit/saveType`, {
      method: "post",
      body: JSON.stringify({
        moduleType: "web",
        type,
      }),
      headers: {
        appId: "E9A27605CEB3FFAF48F4D7B86858A03D9868419F60B5A45027FB6E6867F4EDA9",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.text()) //请求得到的数据转换为text
    .then((res) => {});
}